import { render, staticRenderFns } from "./ResalesBookings.vue?vue&type=template&id=3149a5f2"
import script from "./ResalesBookings.vue?vue&type=script&lang=js"
export * from "./ResalesBookings.vue?vue&type=script&lang=js"
import style0 from "./ResalesBookings.vue?vue&type=style&index=0&id=3149a5f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports